import React from "react";
import "../style.css";
import LoginForm from "../loginComponents/LoginForm";
import { NavLink } from "react-router-dom";

const LoginSection = () => {
    return (
        <section className="login-section py-5">
            <div className="container py-5">
                <div className="row g-5 py-5">
                    {/* Left side - Login Form */}
                    <div className="col-lg-5 col-md-12">
                        <div className="login-form-wrapper">
                            <div className="login-form-content">
                                <h1 className="login-title">
                                    Turn your opinions into rewards with us.
                                </h1>

                                <LoginForm />

                                {/* Switch Link */}
                                <div className="auth-switch-link mt-4">
                                    <p>
                                        Don't have an account?{" "}
                                        <NavLink to="/register">Register here</NavLink>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Right side - Video */}
                    <div className="col-lg-7 col-md-12">
                        <div className="login-image-wrapper">
                            <video
                                src="./images/login.mp4"
                                autoPlay
                                loop
                                muted
                                playsInline
                                className="login-background-image"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default LoginSection;
